// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__rK8_k","itemTitle":"ClientEmergencyInfo_itemTitle__3jwPP","itemText":"ClientEmergencyInfo_itemText__3Na7D"};